import { useEffect, useRef, useState } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { formatMsToMinutes } from "../utils/time.utils";

const ProgressBar = ({ label, estado, progreso = 0, tiempo = 0 }) => {
  const [smoothValue, setSmoothValue] = useState(0);
  const fromRef = useRef(0);

  const safeValue = Math.min(100, Math.max(0, smoothValue));

  useEffect(() => {
    let raf;
    let start;
    const from = fromRef.current;
    const to = progreso;
    const duration = 300;

    const animate = (timestamp) => {
      if (!start) start = timestamp;
      const p = Math.min((timestamp - start) / duration, 1);

      const value = from + (to - from) * p;
      setSmoothValue(value);

      if (p < 1) {
        raf = requestAnimationFrame(animate);
      } else {
        // dejamos el valor final como nuevo punto de partida
        fromRef.current = to;
      }
    };

    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [progreso]);

  const color =
    estado === "error"
      ? "error"
      : estado === "en_progreso"
      ? "warning"
      : estado === "completado"
      ? "success"
      : "inherit";

  const text =
    estado === "completado"
      ? `Completado${tiempo ? ` (${formatMsToMinutes(tiempo)})` : ""}`
      : estado === "en_progreso"
      ? `En progreso (${progreso}%)`
      : estado === "error"
      ? "Error"
      : "Pendiente";

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2">
        {label} — {text}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={safeValue}
        color={color}
        sx={{ height: 10, borderRadius: 5 }}
      />
    </Box>
  );
};

export default ProgressBar;
